(function () {
  var NAMES = { light: "Lightweight", mid: "Midweight", heavy: "Heavyweight" };
  var OLD = {};
  function fleece(e) { return e && e.t === "fleece"; }
  var TESTS = {
    light: function (e) { var w = e.wt; return w > 0 && (fleece(e) ? w < 7 : w < 5); },
    mid: function (e) { var w = e.wt; return fleece(e) ? w >= 7 && w < 9 : w >= 5 && w < 6.05; },
    heavy: function (e) { var w = e.wt; return fleece(e) ? w >= 9 : w >= 6.05; }
  };
  function relabel(root) {
    if (!root) return;
    var els = root.querySelectorAll ? root.querySelectorAll("*") : [];
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      for (var c = el.firstChild; c; c = c.nextSibling) {
        if (c.nodeType !== 3) continue;
        var t = c.nodeValue, u = t;
        for (var k in OLD) if (OLD[k] && u.indexOf(OLD[k]) > -1) u = u.split(OLD[k]).join(NAMES[k]);
        if (u !== t) c.nodeValue = u;
      }
    }
  }
  function labels() {
    var g = document.getElementById("groups");
    if (g) {
      Array.prototype.forEach.call(g.querySelectorAll(".opt[data-g=weight]"), function (o) {
        var k = o.dataset.k, name = NAMES[k];
        if (!name) return;
        var done = false;
        for (var c = o.firstChild; c; c = c.nextSibling) {
          if (c.nodeType === 3 && c.nodeValue.replace(/\s+/g, "")) { if (c.nodeValue !== name) c.nodeValue = name; done = true; break; }
        }
        if (!done) relabel(o);
      });
    }
    relabel(document.getElementById("chips"));
  }
  function patch() {
    var W = window.WEIGHTS;
    if (!Array.isArray(W) || !window.STYLES) return false;
    if (W.rvaWt) return true;
    W.forEach(function (w) {
      if (!TESTS[w.k]) return;
      OLD[w.k] = w.n;
      w.n = NAMES[w.k];
      w.test = TESTS[w.k];
    });
    W.rvaWt = 1;
    return true;
  }
  function wrapRender() {
    var r = window.render;
    if (typeof r !== "function" || r.rvaWt) return;
    var g = function () { var out = r.apply(this, arguments); try { labels(); } catch (e) {} return out; };
    g.rvaWt = 1;
    for (var k in r) if (Object.prototype.hasOwnProperty.call(r, k)) g[k] = r[k];
    window.render = g;
  }
  function start() {
    if (!patch()) return false;
    wrapRender();
    labels();
    try { if (document.getElementById("groups") && typeof window.render === "function") window.render(); } catch (e) {}
    return true;
  }
  if (!start()) {
    var tries = 0, iv = setInterval(function () { if (start() || ++tries > 200) clearInterval(iv); }, 50);
  }
})();
